import { render, staticRenderFns } from "./ViewScopingResearchPlan.vue?vue&type=template&id=25da15ac"
import script from "./ViewScopingResearchPlan.vue?vue&type=script&lang=js"
export * from "./ViewScopingResearchPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports